var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76837 4H16.2316C17.4074 4 18 4.55497 18 5.68372V13.6038C18 14.7231 17.4074 15.2875 16.2316 15.2875H3.76837C2.59259 15.2875 2 14.7231 2 13.6038V5.68372C2 4.55497 2.59259 4 3.76837 4ZM9.9953 12.0894L16.3351 6.88771C16.5608 6.69959 16.7396 6.2669 16.4574 5.88125C16.1846 5.49559 15.6861 5.48618 15.3568 5.72134L9.9953 9.35215L4.64315 5.72134C4.31393 5.48618 3.8154 5.49559 3.54262 5.88125C3.26044 6.2669 3.43915 6.69959 3.6649 6.88771L9.9953 12.0894Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d3eb1d1611c8fee7e3e4e3beb4fba587.svg";
export { ForwardRef as ReactComponent };